"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.PrevisuFenetrePasse = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _previsuPasse = require("./previsuPasse");

var PrevisuFenetrePasse = function PrevisuFenetrePasse(props) {
  var _ref;

  var couleurInterieur = props.couleurInterieur,
      couleurAme = props.couleurAme,
      image = props.image,
      borderBottom = props.borderBottom,
      borderRight = props.borderRight,
      pp = props.pp,
      ppOuverture = props.ppOuverture;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "feuillePasse",
    style: {
      width: "100%",
      height: "100%",
      position: "relative"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "interieurFeuille",
    style: (_ref = {
      background: "transparent",
      border: (0, _previsuPasse.getFiletSize)() + "px solid " + couleurAme,
      position: "absolute",
      width: "100%",
      height: "100%"
    }, _ref["background"] = couleurInterieur, _ref.right = borderRight, _ref.bottom = borderBottom, _ref.borderRadius = typeof pp.forme !== 'undefined' && pp.forme === 'ovale' ? Math.ceil(ppOuverture.width / 2) + "px" + (ppOuverture.width === ppOuverture.height ? '' : '/50%') : 0, _ref)
  }, image !== null ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      backgroundSize: "cover",
      height: hauteurSujet * cmToPx,
      width: largeurSujet * cmToPx,
      display: "inline-block",
      backgroundImage: "url(" + image + ")"
    }
  }, " ") : ""));
};

exports.PrevisuFenetrePasse = PrevisuFenetrePasse;
PrevisuFenetrePasse.defaultProps = {
  couleurAme: "#FFF",
  couleurInterieur: "transparent"
};
PrevisuFenetrePasse.propTypes = {
  couleurInterieur: _propTypes.default.string,
  couleurAme: _propTypes.default.string,
  borderRight: _propTypes.default.number,
  borderBottom: _propTypes.default.number,
  image: _propTypes.default.string
};
var _default = PrevisuFenetrePasse;
exports.default = _default;